<template>
  <main class="dashboard" v-loading="false">
    <!-- //START of top search section -->
    <div class="flex items-center py-3 flex-wrap">
      <div class="md:w-6/12 w-full mt-2">
        <h2 class="dashboard-header">Dashboard Overview</h2>
        <span>{{ currentDate }}</span>
      </div>
      <div class="md:w-6/12 w-full flex justify-end mt-2">
        <el-date-picker
          type="date"
          placeholder="Start Date"
          style="margin: 0"
          class="mr-3"
          v-model="startDate"
        />
        <el-date-picker
          type="date"
          placeholder="End Date"
          style="margin: 0"
          class="mr-3"
          v-model="endDate"
        />
        <primary-button
          class="shadow-md font-normal"
          buttonText="Search"
          :loading="isLoading"
          @click="getAllOverview"
        />
      
      </div>
    </div>
    <!-- //End of top search section -->

    <section class="mt-12 shadow-md rounded-xl">
      <div v-loading="isLoading">
        <div class="flex justify-end w-full px-4 pt-4"></div>
        <div class="flex items-center px-4 py-4 flex-wrap item">
          <div class="w-6/12 font-bold">My Shipments Metric</div>
          <div class="w-6/12 justify-end flex">
            <div class="w-48">
              <el-select
                filterable
                v-model="location"
                placeholder="Select city"
              >
                <el-option
                  v-for="city in [
                    'Weekly',
                    'Monthly',
                    'Yearly',
                    '60 Day',
                    '30 Day',
                    'Switch to Custom Date',
                  ]"
                  :key="city"
                  :label="city"
                  :value="city"
                >
                  <span
                    v-if="city == 'Switch to Custom Date'"
                    class="text-primary-yellow"
                    >Switch to Custom Date</span
                  >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <SMChart :deliverySent="deliverySent" />
      </div>

      <div id="content" >
        <div v-for="(chartData, index) in chartsData" :key="index" :class="{ 'Recent-Shipments': index === 0, 'Top-Destinations': index === 1, 'Top-Providers': index === 2}" >
            <Tops :showLabels="chartData.showLabels" :fontSize="chartData.fontSize" :keys="chartsData[index].id" :showTotal="chartData.showTotal" :totalLabel="chartData.totalLabel" :header="chartData.header" :colors="chartData.colors" :labels="chartData.labels" :series="chartData.series" />
        </div>
      </div>
      <SSChart :shippingSpend="shippingSpend" /> 
    </section>
  </main>
</template>

<script>
import SMChart from "@/components/Ondemand/Analytic/modules/ShipmentMetric.vue";
import SSChart from "@/components/Ondemand/Analytic/modules/ShippingSpend.vue"
import Tops from "@/components/Ondemand/Analytic/modules/Tops.vue"
import moment from "moment";

export default {
  components: {
    SMChart,
    SSChart,
    Tops,
  },
  data() {
    return {
      startDate: "",
      endDate: "",
      dateFilter: "custom",
      analyticData: {},
      recenShippment: [],
      topProvider: [],
      topDestination: [],
      shippingSpend: [],
      shippmentMetric: {}, 
      deliverySent: [],
      isLoading: false,          
      chartsData: [
        {
          series: [0],
          labels: [""],
          colors: [''],
          header: 'Recent Shipments',
          totalLabel:['no data available'],
          showTotal: 'null',
          showLabels: true,
          fontSize: "14px",
          id: 0,
        },
        {
          series: [0],
          labels: [""],
          colors: [''],
          header: 'Top Destinations',
          totalLabel:['no data available'],
          showTotal: '',
          showLabels: true,
          id: 1,
        },
        {
          series: [0],
          labels: [''],
          colors: [''],
          header: 'Top Providers',
          totalLabel: ['no data available'],
          showTotal: '',
          showLabels: true,
          id: 2,
        }
      
      ]
    };
  },
  mounted() {
    this.getAllOverview();
  },

  computed: {
    currentDate() {
      return moment().format("Do MMMM, YYYY"); 
    },
    payload() {
      return {
        startDate: this.startDate
          ? moment(this.startDate).format("YYYY-MM-DD")
          : "2023-01-05",
        dateFilter: this.dateFilter,
        endDate: this.endDate
          ? moment(this.endDate).format("YYYY-MM-DD")
          : "2023-01-06",
        userId: localStorage.getItem("userId"),
      };
    }, 
  },
  methods: {
    loadShippmentMetric() {
      this.shippmentMetric = this.analyticData.shipmentMetric
      const deliverySent = this.shippmentMetric.deliverySent
      this.deliverySent = deliverySent
    },
    loadShippingSpend() {
      this.shippingSpend = this.analyticData.shippingSpend
    },   
    loadTopProvider() {
      this.topProvider = this.analyticData.topProvider
      this.topProvider.forEach(item => {
          item.count = parseInt(item.count, 10);
        });
        this.topProvider.sort((a, b) => b.count - a.count);
      const topFiveCounts = this.topProvider.slice(0, 5);
      if (topFiveCounts.length === 0) {
      this.chartsData[2].series 
      } else {
      const counts = topFiveCounts.map(shipment => parseInt(shipment.count)); 
      this.chartsData[2].series = counts;          
      }
      const companyName = this.topProvider.map(provider => provider.companyname || 'N/A');
      for (let i = 0; i < companyName.length; i++) {
        this.chartsData[2].labels[i] = companyName[i] 
        this.remove3LastItem()
        this.chartsData[2].totalLabel.push('Top Providers')
        this.chartsData[2].colors.push('#09B78A', '#FFA600', '#383F51', '#FE4D3C', '#A5ADB7')
      }
    },
    loadTopDestination() {
      this.topDestination = this.analyticData.topDestination
      this.topDestination.forEach(item => {
          item.count = parseInt(item.count, 10);
        });
        this.topDestination.sort((a, b) => b.count - a.count);
      const topFiveCounts = this.topDestination.slice(0, 5);
      if (topFiveCounts.length === 0) {
      this.chartsData[1].series 
      } else {
        const counts = topFiveCounts.map(destination => (destination.count));
      this.chartsData[1].series = counts;            
      }      
      const states = topFiveCounts.map(destination => destination.state || 'NULL');
      for (let i = 0; i < states.length; i++) {
        this.chartsData[1].labels[i] = states[i]

      this.remove2LastItem()
      this.chartsData[1].totalLabel.push('Top 5 States')
      this.chartsData[1].colors.push('#FFA600', '#D72638', '#7A90A7', '#09B78A', '#383F51')
      }
    },
    loadRecentShippment() {
      this.recenShippment = this.analyticData.recenShippment; 
      if (this.recenShippment.length === 0 ) {
        this.chartsData[0].series   
      } else {
      const counts = this.recenShippment.map(shipment => parseInt(shipment.count)); 
      this.chartsData[0].series = counts;     
      const totalCount = this.chartsData[0].series.reduce((sum, count) => sum + count, 0);
      const deliveryStatuses = this.recenShippment.map(shipment => shipment.deliveryStatus);
      for (let i = 0; i < deliveryStatuses.length; i++) {
        const percentage = this.recenShippment.map(shipment => (parseInt(shipment.count) / totalCount) * 100);
        this.chartsData[0].labels[i] = deliveryStatuses[i]
        .charAt(0).toUpperCase() + deliveryStatuses[i]
        .slice(1) + ':' + percentage[i].toFixed(2) + '%'
        this.removeLastItem(i)
      } 
      
      this.chartsData[0].totalLabel.push('Shipments')
      this.chartsData[0].colors.push('#D72638', '#09B78A', '#FFA600', '#7A90A7')
      }    
    },
    removeLastItem(i) {
      this.chartsData[i].totalLabel.pop();
      this.chartsData[i].colors.pop();
    },
    remove2LastItem() {
      this.chartsData[1].totalLabel.pop();
      this.chartsData[1].colors.pop();
    },
    remove3LastItem() {
      this.chartsData[2].totalLabel.pop();
      this.chartsData[2].colors.pop();
    },
    async getAllOverview() {
      // if (this.endDate < this.startDate) return;
      this.isLoading = true;
      try {
        await this.$_getAllOverview(this.payload)
        .then((res) => {
          if (res.status !== 200) {
                throw Error('response unavailable')
            } 
            this.analyticData = res.data; 
            this.loadShippmentMetric();          
            this.loadShippingSpend();         
            this.loadRecentShippment();          
            this.loadTopProvider();
            this.loadTopDestination();                                           
        });
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1100px){
#content{
			display: grid;
			grid-template-columns: repeat(2, 1fr);
      grid-gap: 10px;
      width: 97%;			
      grid-template-areas: 
      "RS TD"
      "TP TP";
		}
  }
    #content >*{
      border: 2px solid transparent;
      border-radius: 8px;
      box-shadow: 0px 0px 8px 2px #00000014;
      margin: 0;
		}
    #content .Top-Providers {
      width: 50%;
      margin: 0 auto;
    }
    .Recent-Shipments{
         grid-area: RS;
     }
    .Top-Destinations{
        grid-area: TD;
    }
    .Top-Providers{
        grid-area: TP;
    }
    @media (max-width: 1100px) { 
      #content .Top-Providers {
      width: 100%;
      margin: 0;
    }
    }
            
section{
  @apply  border-transparent border-solid border-2 shadow-xl ;
}
.dashboard-header {
  @apply py-2;
  font-size: 24px;
}

.dashboard {
  @apply bg-white p-4 pb-24;
}

.MD-section {
  @apply w-full text-center bg-primary-navy text-white py-6 border-r-2 border-gray-500;
}

.IC-section {
  @apply w-full text-center;
}
.turn-up {
  transform: rotateZ(180deg);
}
.turn-off {
  transform: rotateZ(0deg);
}
</style>